export enum TipoPesquisaProduto {
    cnae = 1,
    codigo = 2,
    descricao = 3
}

export enum TipoDocumentoEnum {
    MC = 1,
    SomenteServicos = 10,
    SomenteMateriais = 20,
    MateriaisServico = 30,
    Concessionaria = 40,
    ConhecimentoTransporte = 50,
    Contratos = 60,
    GuiaISSComplementar = 70,
    Terrenos = 80,
    RpaUrbamais = 81,
    RPA = 82,
    NotaFiscalComissionamentoPJ = 83,
    Elevadores = 101,
    Outros = 106
}
export enum TipoProtocoloEnum {
    MrvPagLegado = 0,
    MrvPagNaoFiscal = 1,
    MrvPagFiscal = 2
}

export enum ProtocoloFiscalPageEnum {
    NonExpanded = -1,
    Cabecalho = 0,
    FichaProtocolo = 1,
    Pedidos = 2,
    Produtos = 3,
    Medicoes = 4,
    Ratetio = 5
}

export enum TipoFiscalEnum {
    SimplesRemessa = 10,
    Normal = 20,
    Bonificacao = 30,
    Brinde = 40
}
